import styled from "styled-components";
import { theme } from '../../theme'

export const LogoContent = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    padding: 21px 26px;
    height: 6.4rem;
`;

export const LogoContainer = styled.div`
    display: ${({ compact }) => compact ? "none" : "block"};
    @media(max-width: 920px) {
        display: block;
    }
`;

export const IconContainer = styled.div`
    display: ${({ mobile }) => mobile ? "none" : "flex"};
    cursor: pointer;
    margin-left: ${({ compact }) => compact ? "0px" : "5.4rem"};
    transition: all 0.2s linear;
    transform: rotate(${({ compact }) => compact ? "180deg" : "0deg"});

    @media(max-width: 920px) {
        display: ${({ mobile }) => mobile ? "flex" : "none"};
        transform: none;
        margin-left: 5.4rem;
    }
`;